import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { makeStyles } from "@material-ui/core/styles";

const AddItemToUnit = ({
  items,
  size,
  handleClose,
  open,
  onItemClick,
  location,
}) => {
  const classes = useStyles();
  const [search, setSearch] = useState("");
  const [filterItems, setFilterItems] = useState();
  useEffect(() => {
    if (!search) {
      setFilterItems(items);
    } else {
      const newItems = {};
      Object.keys(items).forEach((key) => {
        if (items[key]?.title?.toLowerCase().includes(search.toLowerCase())) {
          newItems[key] = items[key];
        }
      });

      setFilterItems(newItems);
    }
  }, [search, items]);

  const _renderItems = () => {
    if (!filterItems) {
      return null;
    }

    const newItems = Object.keys(filterItems)
      .map((key) => {
        return {
          ...filterItems[key],
          key: key,
        };
      })
      .sort((a, b) => b.cellSize - a.cellSize)
      .filter(
        (e) =>
          (open === "Scooter" || open === "Bicycle"
            ? e.title && e.title.includes(open)
            : e.type !== "ride") && e.location.includes(location)
      );

    return newItems?.map((item, index) => {
      const key = item.key;

      if (open === "unit" && item.cellSize > size) {
        return null;
      }

      return (
        <ItemWrapper
          onClick={() => {
            onItemClick(key);
          }}
          key={`${item.title}_${index}`}
        >
          <ItemText>
            <img
              style={{ objectFit: "contain" }}
              width={55}
              height={55}
              src={item.image}
              alt={"item"}
            />
            <div style={{ marginLeft: "10px" }}>
              <div style={{ marginBottom: "4px" }}>
                <Span>{item.title}</Span>
              </div>
              <div style={{ marginBottom: "4px" }}>
                <Span
                  style={{
                    fontSize: "12px",
                  }}
                >
                  {item.model}
                </Span>
              </div>
              <div style={{ marginBottom: "4px" }}>
                <Span
                  style={{
                    fontSize: "12px",
                  }}
                >{`Cell size: ${item.cellSize}`}</Span>
              </div>

              <div style={{ marginBottom: "4px" }}>
                <Span
                  style={{
                    color: item.color,
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >{`Category: ${item.category}`}</Span>
              </div>
            </div>
          </ItemText>
        </ItemWrapper>
      );
    });
  };

  return (
    <Modal
      disableEnforceFocus
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={!!open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={!!open}>
        <Wrapper>
          <Input
            type="text"
            placeholder="Search item"
            name="Search item"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />

          {_renderItems()}
          <CloseWrapper
            onClick={() => {
              if (search) {
                setSearch("");
              } else {
                handleClose();
              }
            }}
          >
            <FontAwesomeIcon color={"#4b4b4b"} icon={faTimes} />
          </CloseWrapper>
        </Wrapper>
      </Fade>
    </Modal>
  );
};

export { AddItemToUnit };

const ItemText = styled.div`
  position: relative;
  flex-direction: row;
  align-self: start;
  align-items: center;
  display: flex;
  padding: 10px;
  border-bottom: 1px solid #dcdcdc;
`;

const Span = styled.span`
  font-family: Manrope, serif;
  line-height: 1.2;
  font-size: 14px;
  color: #707070;
`;
const Wrapper = styled.div`
  background-color: white;
  border-radius: 25px;
  outline: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 90%;
  overflow: auto;
  width: 50%;
`;
const ItemWrapper = styled.div`
  cursor: pointer;
`;

const Input = styled.input`
  color: #2d5566;
  padding: 1em;
  border: 1px solid #dcdcdc;
  border-radius: 5px;

  &::-webkit-input-placeholder {
    color: #2d5566;
    padding-left: 0.25em;
  }
`;

const CloseWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  margin: 15px;
  cursor: pointer;
`;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    "&:focus": {
      outline: 0,
    },
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    outline: "none",
  },
}));
